import React, { Suspense, lazy } from "react";
const ReactApexChart = lazy(() => import("react-apexcharts"));

const BarChart0 = ({ chart_title, chart_data = [], chart_categories = [] }) => {
  const series = [
    {
      name: "No. Orders", 
      data: Array.isArray(chart_data)
        ? chart_data.map((v) => (typeof v === "number" ? v : 0))
        : [],
    },
  ];

  const chartOptions = {
    chart: {
      type: "bar",
      height: 350,
    },
    plotOptions: {
      bar: {
        borderRadius: 4,
        borderRadiusApplication: "end",
        horizontal: false,
        barHeight: "27%",
      },
    },
    dataLabels: {
      enabled: false,
    },
    tooltip: {
      y: {
        formatter: (val) => `${val} Orders`, // ✅ tooltip shows only number + "Orders"
      },
    },
    xaxis: {
      categories: Array.isArray(chart_categories)
        ? chart_categories.map((v) =>
            v !== undefined && v !== null ? v.toString() : ""
          )
        : [],
    },
    title: {
      text: chart_title || "",
      align: "center",
    },
  };

  return (
    <div className="d-flex justify-content-center align-items-center w-100">
      <Suspense
        fallback={<div style={{ textAlign: "center" }}>Loading chart...</div>}
      >
        <ReactApexChart
          options={chartOptions}
          series={series}
          type="bar"
          height={350}
          className ="w-100"
        />
      </Suspense>
    </div>
  );
};

export default BarChart0;
